import { render, staticRenderFns } from "./orderResult.vue?vue&type=template&id=b8f5dfb6&scoped=true"
import script from "./orderResult.vue?vue&type=script&lang=js"
export * from "./orderResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f5dfb6",
  null
  
)

export default component.exports